<template>
<footer class="footer">
  <div class="footer-container">
    <div class="footer-note">
      <p>&copy; 2026 FMWhatsApp Official | All Rights Reserved</p>
    </div>
    <div class="footer-links">
      <a href="/about/" class="footer-link" @click.prevent="goRoute('/about/')">About Us</a>
      |
      <a href="/contact/" class="footer-link" @click.prevent="goRoute('/contact/')">Contact</a>
      |
      <a href="/privacy-policy/" class="footer-link" @click.prevent="goRoute('/privacy-policy/')">Privacy Policy</a>
      |
      <a href="/terms-of-service/" class="footer-link" @click.prevent="goRoute('/terms-of-service/')">Terms of Service</a>
      |
      <a href="/dmca/" class="footer-link" @click.prevent="goRoute('/dmca/')">DMCA</a>
      |
      <a href="/disclaimer/" class="footer-link" @click.prevent="goRoute('/disclaimer/')">Disclaimer</a>
    </div>

  </div>
</footer>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    // 中文注释：页脚统一使用 Vue Router 跳转
    goRoute(path) {
      if (!this.$router) return
      this.$router.push(path).catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: #f5f5f5;
  color: #6b6b6b;
  padding: 24px 0 28px;
}
@media (max-width: 768px) {
  .footer {
    padding: 16px 0 18px;
  }
}

.footer-container {
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 8px;
}

.footer-links {
  display: flex;
  gap: 6px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}

.footer-link {
  color: #0b7f73;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #22a85b;
}

.footer-note {
  width: 100%;
  font-size: 16px;
  line-height: 1.6;
  font-weight: 500;

  p {
    margin: 0;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    gap: 10px;
  }

  .footer-links {
    justify-content: center;
    margin-bottom: 0;
    gap: 6px;
  }

  .footer-note {
    font-size: 16px;
  }

  .footer-link {
    font-size: 16px;
  }
}
</style>
